import { render, staticRenderFns } from "./dict-info.vue?vue&type=template&id=50f22ae9&"
import script from "./dict-info.vue?vue&type=script&lang=js&"
export * from "./dict-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dict-info.vue"
export default component.exports